import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Select, OfferTile } from "../../partials";
import { groupDealerships, insertParam, formatGroupLabel } from "~/js/utils";
import FormDynamic from "./forms/FormDynamic";
import FormTestDrive from "./forms/FormTestDrive";
import FormTestDriveSpecific from "./forms/FormTestDriveSpecific";
import FormBookService from "./forms/FormBookService";
import FormServiceEnquiry from "./forms/FormServiceEnquiry";
import FormMakeAnOffer from "./forms/FormMakeAnOffer";
import FormPlaceADeposit from "./forms/FormPlaceADeposit";
import FormMakeTradeEnquiry from "./forms/FormMakeTradeEnquiry";
import FormMakeAnEnquiry from "./forms/FormMakeAnEnquiry";
import FormMakeAnEnquiryPassedEmail from "./forms/FormMakeAnEnquiryPassedEmail";
import FormMakeAFinanceEnquiryVDP from "./forms/FormMakeAFinanceEnquiryVDP";
import FormPartsEnquiry from "./forms/FormPartsEnquiry";
import FormAutobodyEnquiry from "./forms/FormAutobodyEnquiry";
import FormFinanceEnquiry from "./forms/FormFinanceEnquiry";
import FormVehicleFinanceCalculator from "./forms/FormVehicleFinanceCalculator";
import SuccessPopup from "./SuccessPopup";
import SharePopup from "./SharePopup";
import ShareURLPopup from "./ShareURLPopup";
import FormVirtualAppointment from "./forms/FormVirtualAppointment";
import FormVirtualAppointmentSpecific from "./forms/FormVirtualAppointmentSpecific";
import {enableBodyScroll} from "body-scroll-lock";

const makes = [{ value: '', label: 'All Brands' }];

class InlineForm extends Component {
    forms = {
        "dynamic-form": FormDynamic,
        "test-drive": FormTestDrive,
        "test-drive-no-dealer": FormTestDrive,
        "test-drive-branded": FormTestDrive,
        "test-drive-offer": FormTestDrive,
        "test-drive-specific": FormTestDriveSpecific,
        "test-drive-dealer": FormTestDrive,
        "book-service": FormBookService,
        "book-service-enquiry": FormServiceEnquiry,
        "book-service-dealer": FormBookService,
        "book-service-branded": FormBookService,
        "book-service-no-dealer": FormBookService,
        "make-an-offer": FormMakeAnOffer,
        "place-a-deposit": FormPlaceADeposit,
        "make-trade-enquiry": FormMakeTradeEnquiry,
        "make-an-enquiry": FormMakeAnEnquiry,
        "make-an-enquiry-passed-email": FormMakeAnEnquiryPassedEmail,
        "make-an-enquiry-brand-page": FormMakeAnEnquiry,
        "make-an-enquiry-specific": FormMakeAnEnquiry,
        "make-an-enquiry-offer": FormMakeAnEnquiry,
        "make-an-enquiry-all": FormMakeAnEnquiry,
        "register-your-interest": FormMakeAnEnquiry,
        "make-an-enquiry-favourites": FormMakeAnEnquiry,
        "make-a-finance-enquiry-vdp": FormMakeAFinanceEnquiryVDP,
        "parts-enquiry": FormPartsEnquiry,
        "parts-enquiry-dealer": FormPartsEnquiry,
        "parts-enquiry-branded": FormPartsEnquiry,
        "parts-enquiry-no-dealer": FormPartsEnquiry,
        "autobody-enquiry": FormAutobodyEnquiry,
        "finance-enquiry": FormFinanceEnquiry,
        "finance-enquiry-offer": FormFinanceEnquiry,
        "vehicle-finance-calculator": FormVehicleFinanceCalculator,
        success: SuccessPopup,
        "share-favourites": SharePopup,
        "share-url": ShareURLPopup,
        "virtual-appointment": FormVirtualAppointment,
        "virtual-appointment-specific": FormVirtualAppointmentSpecific,
    };

    // forms = FormMethods.getForms()

    state = {
        type: null,
        brand: null,
        region: null,
        dealer: null,
        successMsg: {},
        isOpen: false,
        formId: null,
        shareTitle: null,
        passedEmail: null,
    };



    constructor(props){
        super(props);
        const { type, formId, modelPrefill, shareTitle, additionalData, email, models, regions} = this.props;
        const urlParams = new URLSearchParams(window.location.search);
        const self = this;
    };

    componentDidMount(){
    }


    showSuccessPopup = ({ title, text }) => {
        this.setState({
            type: "success",
            successMsg: { title, text },
        });
        document.getElementById('scroll-anchor').scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    };

    close = () => {
        this.setState({  type: this.props.type });
    };

    render() {
        let Component = () => null;

        let {
            type,
            isOpen,
            successMsg,
            brand,
            region,
            passedEmail,
            dealer,
            formId,
            modelPrefill,
            shareTitle,
            additionalData,
            models,
            regions,
        } = this.state;

        if(!type){
            type = this.props.type;
        }
        if(!regions){
            regions = this.props.regions;
        }
        if(!models && type === "make-trade-enquiry"){
            models = this.props.models;
        }


        let props = {
            close: this.close,
            showSuccessPopup: this.showSuccessPopup,
            inline: true,
            successMsg,
            type,
            passedEmail,
            brand,
            region,
            dealer,
            modelPrefill,
            shareTitle,
            additionalData,
            models,
            regions,
        };

        if (this.state.type) {
            Component = this.forms[this.state.type];
        }else{
            Component = this.forms[this.props.type];
        }

        if (this.props.type == "dynamic-form" || this.props.type == "place-a-deposit") {
            this.props.type.formId = formId;
        }
        return (
            <div class={`is-popup-open`} id={`inline-form`} class={`inline-form-container`}>
                {this.props.type != "place-a-deposit" ? (
                    <Component {...props} />
                ) : null}

            </div>
        );
    }

}

export default function (el, props) {
    ReactDOM.render(<InlineForm {...props} />, el)
}
